import React, { createContext, useContext, useEffect, useState } from 'react';
import FeedbackContext from './FeedbackContext';
import StoreContext from './StoreContext'
import { useBebackApi } from '../hooks/useBebackApi';
import { removeWOs } from '../helpers/WorkOrders';

const WorkOrderContext = createContext();

const WorkOrderProvider = ({ children }) => {
  const { setIsLoading } = useContext(FeedbackContext);
  const { courtesyLyft, time_zone } = useContext(StoreContext);
  const [workOrders, setWorkOrders] = useState([]);
  const [canceledLyftWorkOrder, setCanceledLyftWorkOrder] = useState(null);
  const { getWorkOrders } = useBebackApi()

  const fetchWorkOrders = async (storeId) => {
    const response = await getWorkOrders(storeId, courtesyLyft);
    if (response?.error || !Array.isArray(response)) {
      setIsLoading(false);
      return;
    }
    setWorkOrders([...response]);
  };

  const updateWorkOrderFields = (workOrder, changedFields) => {
    if(!workOrders || workOrders.length <= 0){
      return;
    }
    const oldWO = workOrders.findIndex(wo => wo.WO === workOrder);
    const WO = workOrders.filter(wo => wo.WO === workOrder)?.[0];
    if(oldWO && WO) {
      const newWO = Object.assign(WO, changedFields);
      workOrders[oldWO] = newWO;
      setWorkOrders([...workOrders])
    }
  }

  const clearWorkOrders = () => {
    setWorkOrders([]);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setWorkOrders(prev => removeWOs(prev, time_zone, courtesyLyft));
    }, 5 * 60 * 1000);
  
    return () => clearInterval(interval);
  }, []);

  const contextValue = {
    workOrders,
    setWorkOrders,
    fetchWorkOrders,
    clearWorkOrders,
    updateWorkOrderFields,
    canceledLyftWorkOrder,
    setCanceledLyftWorkOrder
  };

  return (
    <WorkOrderContext.Provider value={contextValue}>
      {children}
    </WorkOrderContext.Provider>
  );
};

export { WorkOrderContext as default, WorkOrderProvider };
